@if (first; as ticket) {
  @if (isActive) {
  <app-flight-ticket-frame [class]="'ticket--' + tone" [tone]="tone"
    [stops]="itinerary.stops" [connections]="tickets.length - 1"
    [label]="itinerary.roundTrip ? 'Ida e volta' : null"
    [departureTime]="schedule.departureTime" [arrivalTime]="schedule.arrivalTime"
    [arrivesNextDay]="schedule.arrivesNextDay" [connectionStops]="schedule.connectionStops"
    [imageUrl]="imageUrl" [imageAlt]="imageAlt" [cityOf]="cityOf"
    (imageError)="onImageError($event)">
    <span ticketTopStart class="ticket-chip">{{ ticket.departureDateLt | dateFormat: 'DD/MM/YYYY' }}</span>
    <button ticketTopEnd class="ticket-pnr" type="button" (click)="copyValue.emit(ticket.pnrCode)"
      matTooltip="Copiar código de reserva" [attr.aria-label]="'Copiar código de reserva ' + ticket.pnrCode">
      <span class="ticket-pnr__label">Cód. reserva</span>
      <strong class="ticket-pnr__code">{{ ticket.pnrCode }}</strong>
      <img src="assets/images/copy.svg" alt="" />
    </button>

    <div class="ticket-meta">
      <strong class="ticket-flights">{{ flightNumbers }}</strong>
      <span class="ticket-badge">
        @switch (status) {
          @case (StatusTicketCard.CANCELLED) { Cancelado }
          @case (StatusTicketCard.INACTIVE) { Realizado }
          @default { Ativo }
        }
      </span>
    </div>

    <div class="ticket-divider"></div>

    <div class="ticket-when">
      <div class="ticket-when__row">
        <svg class="ticket-when__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><rect x="3" y="4" width="18" height="18" rx="2"/><path d="M16 2v4M8 2v4M3 10h18"/></svg>
        <span class="ticket-when__label">Partida</span>
        <span class="ticket-when__detail">{{ ticket.departureDateLt | dateFormat: 'DD/MM/YYYY · HH:mm' }}</span>
      </div>
      <div class="ticket-when__row">
        <svg class="ticket-when__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><rect x="3" y="4" width="18" height="18" rx="2"/><path d="M16 2v4M8 2v4M3 10h18"/></svg>
        <span class="ticket-when__label">Chegada</span>
        <span class="ticket-when__detail">
          {{ tickets[tickets.length - 1].arrivalDateLt | dateFormat: 'DD/MM/YYYY · HH:mm' }}
          @if (schedule.arrivesNextDay) { <span class="ticket-when__nextday">+1 dia</span> }
        </span>
      </div>
    </div>
    <div class="ticket-schedule">
      <app-continuous-itinerary [segments]="tickets"></app-continuous-itinerary>
    </div>

    <div class="ticket-eticket">
      <span class="ticket-eticket__label">Ticket</span>
      <button class="ticket-eticket__value" type="button" (click)="copyTicketNumber.emit(ticket.ticketNumber)"
        matTooltip="Copiar ticket" [attr.aria-label]="'Copiar ticket ' + ticket.ticketNumber">
        <span>{{ ticket.ticketNumber }}</span>
        <img src="assets/images/copy.svg" alt="" />
      </button>
    </div>

    @if (isActive) {
      <!-- Segment row(s): direct flight gets one leg-line, connections reuse seat-availability. -->
      @if (tickets.length === 1 && seats; as seatSummary) {
        <div class="ticket-leg-line">
          <span class="ticket-leg-line__route"><span class="ticket-leg-line__label">Trecho 1 ·&nbsp;</span>{{ flightNumbers }} ({{ ticket.departure }}→{{ ticket.arrival }})</span>
          <span class="ticket-leg-line__actions">
            <span class="ticket-seats" [attr.data-state]="seatSummary.state">
              <svg class="ticket-seats__icon" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M5 4v9a3 3 0 0 0 3 3h8"/><path d="M8 16v4h9"/></svg>
              {{ seatSummary.label }}
            </span>
            @if (ticket.standbySummary; as standbySummary) {
              <button type="button" class="standby-pill"
                (click)="openStandbyDetail(standbySummary)"
                [attr.aria-label]="standbyTotal(standbySummary) + ' Stand by — clique para detalhar'">
                <svg class="standby-pill__icon" width="14" height="14" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                  <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
                  <circle cx="9" cy="7" r="4"/>
                  <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
                  <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
                </svg>
                <strong>{{ standbyTotal(standbySummary) }}</strong>&nbsp;Stand by
              </button>
            }
          </span>
        </div>
      } @else if (tickets.length > 1) {
        <app-seat-availability class="ticket-availability" [items]="tickets"
          (standbyClicked)="openStandbyDetail($event)"></app-seat-availability>
      }

      <div class="ticket-divider"></div>
      <div class="ticket-actions">
        <a class="web-checking" href="https://www.latamairlines.com/br/pt/check-in"
          target="_blank" rel="noopener noreferrer">Web Check-in <span aria-hidden="true">→</span></a>
        <button class="btn-cancel" type="button" (click)="cancelRequested.emit()">Cancelar voo</button>
      </div>
    }
  </app-flight-ticket-frame>
  } @else {
  <!-- Cancelados / Histórico: route, flights, departure, arrival and the reservation code.
       The ticket number stays on Ativos only. -->
  <article class="compact-ticket" [class.compact-ticket--cancelled]="status === StatusTicketCard.CANCELLED"
    [class.compact-ticket--history]="status === StatusTicketCard.INACTIVE">
    <div class="compact-ticket__media">
      @if (imageUrl && !thumbnailFailed) {
        <img class="compact-ticket__image" [src]="imageUrl" [alt]="imageAlt"
          loading="lazy" decoding="async" referrerpolicy="no-referrer" (error)="onImageError(imageUrl!)" />
      } @else {
        <span class="compact-ticket__fallback" aria-hidden="true">
          <img src="assets/images/airplane_flying.svg" alt="" />
        </span>
      }
    </div>
    <div class="compact-ticket__body">
      <div class="compact-ticket__top">
        <p class="compact-ticket__route">
          {{ compactRoute }}
          @if (compactVia) { <span class="compact-ticket__via">via {{ compactVia }}</span> }
        </p>
        <!-- Histórico: true Utilizado, false Não Utilizado, null/undefined No info. -->
        <span class="compact-ticket__badge" [attr.data-usage]="usage">
          @switch (status) {
            @case (StatusTicketCard.CANCELLED) { Cancelado }
            @case (StatusTicketCard.INACTIVE) {
              @switch (usage) {
                @case ('used') { Utilizado }
                @case ('unused') { Não Utilizado }
                @default { No info }
              }
            }
          }
        </span>
      </div>

      <p class="compact-ticket__meta">
        <span class="compact-ticket__flight">{{ flightNumbers }}</span>
      </p>

      <dl class="compact-ticket__times">
        <div class="compact-ticket__time">
          <dt class="compact-ticket__time-label">Partida</dt>
          <dd class="compact-ticket__when">
            <span class="compact-ticket__datetime">{{ ticket.departureDateLt | dateFormat: 'DD/MM/YYYY · HH:mm' }}</span>
          </dd>
        </div>
        <div class="compact-ticket__time">
          <dt class="compact-ticket__time-label">Chegada</dt>
          <dd class="compact-ticket__when compact-ticket__when--arrival">
            <span class="compact-ticket__datetime">{{ tickets[tickets.length - 1].arrivalDateLt | dateFormat: 'DD/MM/YYYY · HH:mm' }}</span>
            @if (schedule.arrivesNextDay) { <span class="compact-ticket__nextday">&nbsp;+1 dia</span> }
          </dd>
        </div>
      </dl>

      <div class="compact-ticket__codes">
        <button class="compact-ticket__code" type="button" (click)="copyValue.emit(ticket.pnrCode)"
          matTooltip="Copiar código de reserva" [attr.aria-label]="'Copiar código de reserva ' + ticket.pnrCode">
          <span class="compact-ticket__code-label">Reserva</span>
          <strong class="compact-ticket__code-value">{{ ticket.pnrCode }}</strong>
          <img src="assets/images/copy.svg" alt="" />
        </button>
      </div>
    </div>
  </article>
  }
}
